import * as FiIcons from 'react-icons/fi';

export const business = {
  name: 'The Cleaning Bees',
  tagline: 'Turnaround Experts',
  phone: '(512) 555-0147',
  email: 'hello@thecleaningbees.com',
  serviceArea: 'Austin, Texas & surrounding areas',
  logo: 'https://media-manager-c.questera.ai/greta-media/f59708bb9af3ffea40f962a8d12d285c2d07055c5905b57e8f038b23faf998248513260fbde40d878428d8efe8733758/images/aW1hZ2UvcG5n/b3753f35aef015f1f05696d5d11b4695.png',
  socials: {
    instagram: 'https://instagram.com/',
    facebook: 'https://facebook.com/',
    whatsapp: 'https://wa.me/'
  }
};

export const navigation = [
  ['Home', 'home'],
  ['Services', 'services'],
  ['How It Works', 'process'],
  ['About', 'about'],
  ['Service Area', 'service-area'],
  ['FAQ', 'faq']
];

export const trustItems = [
  { label: 'On-Time Turnovers', icon: FiIcons.FiClock },
  { label: 'Off-Site Laundry', icon: FiIcons.FiRefreshCw },
  { label: 'Inventory & Restocking', icon: FiIcons.FiPackage },
  { label: 'Turno Integrated', icon: FiIcons.FiCalendar }
];

export const solutions = [
  ['Clean', 'Professional property turnovers prepared for your next guest.', FiIcons.FiCheckCircle],
  ['Reset', 'Fresh linens, towels, amenities and supplies restored between stays.', FiIcons.FiRefreshCw],
  ['Check', 'Light maintenance checks help catch small problems before they become guest complaints.', FiIcons.FiSearch],
  ['Ready', 'Your property is prepared, stocked and guest-ready for the next arrival.', FiIcons.FiHome]
];

export const services = [
  ['Complete Short-Term Rental Turnovers', 'Seamless property flips timed around your guest schedule, with the goal of having your rental ready for the next arrival.', FiIcons.FiHome],
  ['Off-Site Laundry', 'Linens and towels are washed and prepared off-site, helping us keep turnovers efficient and your property organized.', FiIcons.FiRefreshCw],
  ['Inventory & Restocking', 'We manage owner supplies, guest amenities and inventory so your property stays properly stocked.', FiIcons.FiPackage],
  ['Light Maintenance Checkups', 'Routine checks including charging Ring cameras, replacing smart-lock batteries and identifying small issues before they become bigger problems.', FiIcons.FiTool],
  ['Specialized Cleaning', 'Deep cleaning and safe hazard-removal protocols for situations that require additional attention.', FiIcons.FiShield],
  ['Turno Integration', 'Automated scheduling through Turno gives our team streamlined access to turnover schedules, guest counts and payment workflows.', FiIcons.FiCalendar]
];

export const processSteps = [
  ['Connect Your Property', 'Tell us about your short-term rental and your turnover needs.'],
  ['Sync Your Schedule', 'Our Turno integration gives our team streamlined access to your turnover schedule.'],
  ['We Handle the Turnaround', 'Our team cleans, resets, restocks and checks the property.'],
  ['Your Property Is Ready', 'Enjoy a guest-ready property without managing every detail yourself.']
];

export const advantages = [
  ['Reliable Turnarounds', "We understand that your next guest doesn't wait for a late turnover.", FiIcons.FiClock],
  ['Detail-Focused', 'From linens to smart locks, we pay attention to the small things.', FiIcons.FiEye],
  ['Full-Service', 'Cleaning is only part of the job. We help manage the details around it.', FiIcons.FiLayers],
  ['Hands-Off', 'Spend less time coordinating cleaners, laundry, supplies and property details.', FiIcons.FiCoffee],
  ['Flexible', 'Our operations are designed around the realities of hospitality.', FiIcons.FiShuffle],
  ['Tech-Ready', 'Turno integration helps keep schedules and turnover information organized.', FiIcons.FiWifi]
];

export const faqs = [
  ['Do you only clean short-term rentals?', 'Our services are designed specifically around the needs of short-term rental and vacation-rental properties.'],
  ['Do you provide laundry?', 'Yes. We provide off-site laundry services for linens and towels.'],
  ['Can you restock supplies?', 'Yes. We can manage inventory and restock owner supplies and guest amenities.'],
  ['Do you work with Turno?', 'Yes. Our workflow is designed to integrate with Turno for streamlined scheduling and turnover management.'],
  ['Can you handle last-minute turnovers?', "Our operations are built around the fast-paced nature of short-term rentals. Contact us to discuss your property's specific needs and availability."],
  ['Do you provide maintenance?', 'We provide light maintenance checkups such as charging Ring cameras and replacing smart-lock batteries. Larger repairs or specialized work may require an appropriate third-party professional.'],
  ['What areas do you serve?', 'We primarily serve Austin and surrounding areas.']
];

export const gallery = [
  {
    category: 'Guest-Ready Spaces',
    image: 'https://images.unsplash.com/photo-1616486338812-3dadae4b4ace?auto=format&fit=crop&w=1200&q=85',
    alt: 'Bright guest-ready short-term rental bedroom'
  },
  {
    category: 'Attention to Detail',
    image: 'https://images.unsplash.com/photo-1560185008-b033106af5c3?auto=format&fit=crop&w=1200&q=85',
    alt: 'Beautifully prepared premium guest room'
  },
  {
    category: 'Behind the Turnaround',
    image: 'https://images.unsplash.com/photo-1600566753086-00f18fb6b3ea?auto=format&fit=crop&w=1200&q=85',
    alt: 'Polished short-term rental living area'
  },
  {
    category: 'Guest-Ready Spaces',
    image: 'https://images.unsplash.com/photo-1618221195710-dd6b41faaea6?auto=format&fit=crop&w=1200&q=85',
    alt: 'Clean, welcoming vacation rental interior'
  }
];

export const testimonials = [
  {
    quote: 'The Cleaning Bees took the stress out of managing turnovers. Everything was handled and the property was ready for our next guest.',
    author: 'Property Owner'
  },
  {
    quote: 'One reliable team managing the details between stays is exactly what our portfolio needed.',
    author: 'Short-Term Rental Host'
  }
];